import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface TagProps {
  title: string;
}
const Tag: React.FC<TagProps> = t0 => {
  const $ = _c(2);
  const {
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <div className="border-[1px] border-[#EAD520] font-outfit text-[#767676] rounded-full md:px-4 font-medium text-sm px-3 py-1">{title}</div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Tag;